import { render, staticRenderFns } from "./ModalHomework.vue?vue&type=template&id=1332c176&"
import script from "./ModalHomework.vue?vue&type=script&lang=js&"
export * from "./ModalHomework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports